import { ResponseError, type Middleware } from "@/openapi/generated/runtime";
import { getApiErrorMessage } from "@/lib/utils/api/error-message";

/**
 * OpenAPI throws ResponseError with "Response returned an error code".
 * Replace that with the backend body so toasts using error.message show the real text.
 */
export const attachApiErrorMessageMiddleware: Middleware = {
  post: async ({ response }) => {
    if (response.ok) {
      return response;
    }

    const message = await getApiErrorMessage(
      { response },
      "An error occurred",
    );

    throw new ResponseError(response, message);
  },
};
